import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputMoney, InputSelect, InputSwitch, InputPicklist, InputPercentage } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './amounttype-model';  //editable..
import OwnerPicklist from '../owner/owner-picklist.component';
import JournalgroupPicklist from '../journalgroup/journalgroup-picklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class AmounttypeEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadJournalgroup = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'journalgroup': data?.id, 'journalgroupCaption': data?.name || ''  }  });
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} 
                model={Model} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                }  
                <InputSelect name='calc' label='Calculation' value={this.state.datarow.calc} options={Model.optionCalc} error={this.state.errors?.calc} onChange={this.onChange} />
                {Model.asPercentage(this.state.datarow.calc)?
                <InputPercentage name='value' label='Percentage' value={this.state.datarow.value} error={this.state.errors?.value} onChange={this.onChange} />
                : <InputMoney name='value' label='Value' value={this.state.datarow.value} error={this.state.errors?.value} onChange={this.onChange} />
                }
                <InputPicklist name='journalgroup' label='Journal Group' value={this.state.datarow.journalgroup} caption={this.state.datarow.journalgroupCaption} error={this.state.errors?.journalgroup} onChange={this.onChange} >
                    <JournalgroupPicklist currentId={this.state.datarow.journalgroup} onLoad={this.onLoadJournalgroup}/>
                </InputPicklist>

            </BaseEdit>
        );
    }
}